if (!customElements.get("milestones-swiper")) {
    class MilestonesSwiper extends HTMLElement {
        constructor() {
            super();
            this.swiperInstance = null;
        }

        connectedCallback() {
            this.swiperButtonContainer = this.parentElement.querySelector('.milestones-swiper-button');
            this.initSwiper();
        }

        initSwiper() {
            const swiperContainer = this.querySelector('.swiper');
            let swiperNextButton, swiperPrevButton;
            if (this.swiperButtonContainer) {
                swiperNextButton = this.swiperButtonContainer.querySelector('.swiper-btn-next');
                swiperPrevButton = this.swiperButtonContainer.querySelector('.swiper-btn-prev');
            }


            if (swiperContainer) {
                this.swiperInstance = new Swiper(swiperContainer, {
                    slidesPerView: 'auto',
                    // spaceBetween: 15,
                    navigation: {
                        nextEl: swiperNextButton || undefined,
                        prevEl: swiperPrevButton || undefined,
                    },
                    direction: 'horizontal',
                    breakpoints: {
                        320: {
                            direction: 'vertical',
                            allowTouchMove: false,
                        },
                        750: {
                            direction: 'horizontal',
                            allowTouchMove: true,
                        },
                    }
                });
            } else {
                console.error("Swiper container not found.");
            }
        }


        disconnectedCallback() {
        }
    }

    customElements.define('milestones-swiper', MilestonesSwiper);
}
